const Demo6Projects2 = () => {
    return (
        <section id="projects" className="pb-60 projects-section division">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-8">
                        <div className="section-title title-01 mb-70">
                            <h2 className="h2-md">We Care About The Details</h2>
                            <p className="p-xl">
                                Aliquam a augue suscipit, luctus neque purus ipsum neque dolor primis a libero tempus, blandit and cursus varius and magnis
                                sapien
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col gallery-items-list">
                        <div className="masonry-wrap">
                            {[1, 2, 3, 4, 5, 6].map((item) => (
                                <div key={item} className="project-details masonry-image">
                                    <div className="project-preview rel">
                                        <div className="hover-overlay">
                                            <img
                                                className="img-fluid"
                                                src={`/images/demo6/projects/project-0${item}.jpg`}
                                                alt="project"
                                            />
                                            <div className="item-overlay" />
                                        </div>
                                    </div>
                                    <div className="project-txt">
                                        <h5 className="h5-md">
                                            <a href="#projects">A ligula risus auctor and justo tempus blandit</a>
                                        </h5>
                                        <p className="p-md grey-color">Creative Direction</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="more-btn mt-20">
                            <a href="#pricing" className="btn btn-stateblue tra-grey-hover">
                                View More Projects
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Projects2;
